// Copyright (c) StrangeBee 2023

export const NAME_KEY = {
    user: 'user',
    password: 'password',
    host: 'host',
    port: 'port',
    from: 'from',
    expiration: 'expiration',
    security: 'security',
    tlsRequired: 'tlsRequired',
};
